<template>
  <q-toolbar class="text-black">
    <q-toolbar-title>
      <slot>{{ $('common.html_title_suffix') }}</slot>
    </q-toolbar-title>
    <q-space/>
    <slot name="buttons"/>
  </q-toolbar>
</template>
